import React from 'react';
import PageHeader from "../../components/pageheader/PageHeader";
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFlag, faUser } from '@fortawesome/free-solid-svg-icons';
import HelmetData from "../../components/helmet/HelmetData";

import metaData from "../../datas/metaData.json";
import "./About.css";

export default function About() {
  const navigate = useNavigate();

  const onClick = (path) => {
    navigate(path)
  }
  const data = new Date();
  const experience = data.getFullYear() - metaData.startYear;


  return (
    <>
      <HelmetData
        title="About Me"
        descripton="Know more about my experience in making games and in programming in general"
        canonicalLink="https://www.nabilshelim/#/about"
      />
      <PageHeader title="About Me" icon={faUser} />
      <div id="About" className='about-main'>
        <div className="about-info">
          <h2>My name is {metaData.author}.</h2>
          <p>
            Experienced Game Programmer with 8 years of programming expertise and over 5 years of professional experience in game development. Proficient in Unity and C#, with a strong track record of delivering high-quality gameplay systems, tools, and performance optimizations.
          </p>
          <p>
            Successfully collaborated with solo developers, small teams, and indie studios to develop and ship over a dozen polished titles. Released projects span multiple platforms:
          </p>
          <ul>
            <li>Steam</li>
            <li>Itch.io</li>
            <li>Android</li>
            <li>iOS</li>
          </ul>
      
          <p>And cover a variety of genres:</p>
          <ul>
            <li>Platformers</li>
            <li>Card games</li>
            <li>Strategy games</li>
            <li>Tower Defense</li>
            <li>Turn-based games</li>
            <li>Story-rich games</li>
            <li>Multiplayer games</li>
          </ul>

      <br></br>
      <br></br>
      <h3>Notable Work and Contributions</h3>
      <br></br>
      <ul>
        <li>Developed custom content creation tools that reduced development time by an estimated <strong>40%</strong>.</li>
        <li>Built a fully customized cutscene system tailored to unique art direction, improving narrative implementation speed by <strong>30%</strong>.</li>
        <li>Implemented an efficient, event-driven system for a turn-based game, boosting runtime performance by <strong>25%</strong> and eliminating unnecessary processing loops.</li>
        <li>Created a flexible timing and clock system used for scheduling complex NPC behavior, enabling dynamic in-game interactions.</li>
        <li>Engineered a modified A* pathfinding algorithm adapted for 2D side-scrolling environments, enhancing movement logic and increasing pathfinding efficiency by <strong>35%</strong>.</li>
      </ul>

      <br></br>
      <br></br>
      
      <p>If you're looking for a dedicated and experienced game programmer to join your project or team, feel free to reach out via email at <a target="_blank" href="mailto:nabilshelim@gmail.com">nabilshelim@gmail.com</a> or connect with me on Discord: <a target="_blank" href="https://discord.com/users/565587633024008217">clumsywizard</a>.</p>
        </div>
      </div>
    </>
  )
}
